import { createContext, useEffect, useState, useCallback, useMemo } from 'react'
// import {
//   useContextSelector,
//   createContext as createSelectorContext,
// } from 'use-context-selector'
import { API, graphqlOperation } from 'aws-amplify'
import { getParcoUser } from 'graphql/custom/queries'
import {
  makeTaskRecommendations,
  updateParcoUser,
  updateParcoUserFinances,
  updateParcoUserGoalsTasksAndNotes,
  updateParcoUserFamily,
  updateParcoUserFegli,
  updateParcoUserAddress,
  updateParcoUserSalesforce,
  createParcoUser,
} from 'graphql/custom/mutations'
import { toast } from 'react-toastify'
import { AccountAssumption } from 'admin/utils/AccountAssumption'
import { SessionInformation } from 'admin/utils/SessionInformation'
import { Auth } from 'aws-amplify'
// import { useAuthenticator } from '@aws-amplify/ui-react'
// Swap for other Auth
import { useAuth } from 'components/Authentication/Authentication'
import { AuthProvider } from 'components/Authentication/Authentication'
import { useAccountAssumption } from 'hooks/useAccountAssumption'
import { errorMapping } from 'utils/data/errorMapping'
import { handleSuccessfulLogin } from 'utils/aws/authService'
import { getUser, updateUser as updateUserFunc } from 'admin/utils/queries'
import { apiClient } from 'utils/api/apiClient'

import { decodedToken } from 'utils/aws/authService'
import { useNavigate } from 'react-router-dom'
import { getApiUrl } from 'utils/api/getApiUrl'
import AuthSession from 'admin/utils/AuthSession'

export const IntakeContext = createContext({
  intakeState: {},
  updateIntakeStateAtKey: (object) => console.log(object, 'implement this'),
  updateUser: async () => null,
  isAdmin: false,
  isAgency: false,
})

// export const IntakeContext = createSelectorContext(null)

const IntakeContextWrapper = ({ children }) => {
  const [intakeState, setIntakeState] = useState({})
  const [loading, setLoading] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)
  const [adminDetails, setAdminDetails] = useState({})
  const [isAgency, setIsAgency] = useState(false)
  const [loggedInUserId, setLoggedInUserId] = useState()
  const [userTasks, setUserTasks] = useState()
  const navigate = useNavigate()
  const { signOut: cognitoSignOut, userAttributes: AuthenticatedUser } =
    useAuth()

  const [nonUserState, setNonUserState] = useState({})
  const [currentErrors, setCurrentErrors] = useState({})

  const { assumedUser, setAssumedUser, assumeUserAccount, unassume } =
    useAccountAssumption({ isAdmin })

  const signOut = useCallback(async () => {
    setLoading(true)
    await unassume()
    await cognitoSignOut(() => {
      console.log('clearing session')
      localStorage.removeItem('createdUser')
      localStorage.removeItem('sentToZapier')
      setLoading(false)
      navigate('/')
    })
    // cognitoSignOut()
    // setLoading(false)
  }, [cognitoSignOut, unassume, navigate])

  const createInitialParcoUser = useCallback(
    async ({
      userId,
      email,
      firstName,
      lastName,
      fullName,
      phone,
      dateOfBirth,
      zipcode,
      employmentStatus,
      dateOfHire,
      agency,
      retirementSystem,
      dateOfPlannedRetirement,
      pickYourPath,
      // baseSalary,
      // highThree,
      // currentLeaveBalance,
      // currentSickLeaveBalance,
      // healthInsurance,
      // fehbCode,
      // healthInsurancePremium,
      // netTakeHome,
      // tsp,
      // tspContribution,
      // tspLoans,
      workFromHome,
      returnToOffice,
      forkSelection,
      forkSelectionScenarios,
    }) => {
      if (assumedUser) {
        console.info('cannot create a user for someone you are assumed into')
      }
      const response = await API.graphql(
        graphqlOperation(createParcoUser, {
          // check here for a local forage
          input: {
            id: userId,
            email,
            firstName,
            lastName,
            fullName,
            phone,
            dateOfBirth,
            zipcode,
            employmentStatus,
            dateOfHire,
            agency,
            retirementSystem,
            dateOfPlannedRetirement,
            pickYourPath,
            // baseSalary,
            // highThree,
            // currentLeaveBalance,
            // currentSickLeaveBalance,
            // healthInsurance,
            // fehbCode,
            // healthInsurancePremium,
            // netTakeHome,
            // tsp,
            // tspContribution,
            // tspLoans,
            workFromHome,
            returnToOffice,
            forkSelection,
            forkSelectionScenarios,
            _version: 1,
          },
        })
      )
      return response.data.createParcoUser
    },
    [assumedUser]
  )

  const findUser = useCallback(
    async (userId = null, shouldSetLoading = true) => {
      if (shouldSetLoading) setLoading(true)
      const user = await decodedToken()
      if (!user?.username || user.username === 'undefined') {
        console.error('Invalid user token detected:', user)
        setLoading(false)
        return
      }
      setLoggedInUserId(user.username)
      const userGroups = user['cognito:groups'] || []
      setIsAdmin(userGroups.includes('admins'))
      setIsAgency(userGroups.includes('agency'))

      const demoUserInput =
        (await SessionInformation.getItem('demoUserInput')) || {}
      const lookupId = userId && userId !== 'undefined' ? userId : user.username
      let parcoUser = await getUser(lookupId)

      if (
        (parcoUser.agency === 'Private Sector - Non Federal' &&
          parcoUser.retirementSystem === 'Private Sector - No Pension') ||
        !parcoUser.governmentEmployee
      ) {
        setIsAgency(false)
      } else {
        setIsAgency(true)
      }

      if (!parcoUser) {
        parcoUser = await createInitialParcoUser({
          userId: user.username,
          email: user.attributes.email,
          ...demoUserInput,
        })
      }

      //if demo user exists set the user and then clear
      if (Object.keys(demoUserInput).length !== 0) {
        parcoUser = { ...parcoUser, ...demoUserInput }
        setIntakeState(parcoUser)
        updateUser(parcoUser)
      }

      await SessionInformation.clearAll()
      setIntakeState(parcoUser)

      if (shouldSetLoading) setTimeout(() => setLoading(false), 1000)
      return parcoUser
    },
    [createInitialParcoUser]
  )

  const reloadUser = useCallback(async () => {
    return await findUser(assumedUser || intakeState.id)
  }, [findUser, assumedUser, intakeState.id])

  // const makeRecommendation = useCallback(
  //   async ({ notify = false }) => {
  //     return
  //     // if (assumedUser) return
  //     // const apiUrl = getApiUrl()

  //     // const { data } = await apiClient.post(
  //     //   `${apiUrl}/api/recommend_user_tasks`,
  //     //   { userID: 'test' }
  //     // )
  //     // // recommendedTasks: Task[];
  //     // // taskReminders: Task[];
  //     // // completedTasks: Task[];
  //     // // tasksMarkedIncomplete: Task[];
  //     // // hasUpdatesToSave: boolean;
  //     // setUserTasks(data.user?.tasks || {})

  //     // if (!notify) return
  //     // if (!data.hasUpdatesToSave) return

  //     // if (
  //     //   data.recommendedTasks.length + data.tasksMarkedIncomplete.length >
  //     //   0
  //     // ) {
  //     //   toast.info(
  //     //     `You have ${
  //     //       data.recommendedTasks.length + data.tasksMarkedIncomplete.length
  //     //     } new task recommendation(s)`,
  //     //     {
  //     //       position: 'top-right',
  //     //       autoClose: 5000,
  //     //       pauseOnFocusLoss: false,
  //     //     }
  //     //   )
  //     // }

  //     // if (data.completedTasks.length > 0) {
  //     //   toast.success(
  //     //     `You have completed ${data.completedTasks.length} task(s)! Way to go`,
  //     //     {
  //     //       position: 'top-right',
  //     //       autoClose: 5000,
  //     //       pauseOnFocusLoss: false,
  //     //     }
  //     //   )
  //     // }
  //   },
  //   [assumedUser]
  // )

  // useEffect(() => {
  //   let loaded = false
  //   const loadUser = async () => {
  //     const userId = await AccountAssumption.assumedAs()
  //     findUser(userId)
  //     setAssumedUser(userId)
  //     // makeRecommendation({
  //     //   notify: !window.location.pathname.startsWith('/onboarding'),
  //     // })
  //     loaded = true
  //   }
  //   if (!loaded) loadUser()
  // }, [setAssumedUser, assumedUser, findUser])

  useEffect(() => {
    const loadUser = async () => {
      try {
        // ✅ Wait until an access token is present in AuthSession
        const token = await AuthSession.getItem('accessToken')
        if (!token) {
          console.warn('No token yet — retrying in 500ms...')
          setTimeout(loadUser, 500)
          return
        }

        let retries = 0
        let userId = await AccountAssumption.assumedAs()

        while ((!userId || userId === 'undefined') && retries < 10) {
          console.warn('Waiting for assumed user to become available...')
          await new Promise((res) => setTimeout(res, 150))
          userId = await AccountAssumption.assumedAs()
          retries++
        }

        if (!userId || userId === 'undefined') {
          console.warn(
            'No valid assumed user found after retries, using token user instead.'
          )
        } else {
          // console.log('✅ Assumed user detected:', userId)
        }

        await findUser(userId)
        setAssumedUser(userId)
      } catch (err) {
        console.error('Error during user initialization:', err)
        setLoading(false)
      }
    }

    loadUser()
  }, [findUser, setAssumedUser])

  useEffect(() => {
    const loadAdminDetails = async () => {
      if (isAdmin && loggedInUserId) {
        const adminInfo = await getUser(loggedInUserId)
        setAdminDetails(adminInfo)
      }
    }
    loadAdminDetails()
  }, [isAdmin, loggedInUserId])

  // testing this out
  // const updateIntakeStateAtKey = useCallback(
  //   (object) => {
  //     const newState = { ...intakeState, ...object }
  //     setIntakeState(newState)
  //     return newState
  //   },
  //   [intakeState]
  // )

  // testing this to only change if the object has differences
  const updateIntakeStateAtKey = useCallback(
    (object) => {
      let hasChanged = false
      const newState = { ...intakeState }

      for (const key in object) {
        if (newState[key] !== object[key]) {
          hasChanged = true
          newState[key] = object[key]
        }
      }

      if (hasChanged) {
        setIntakeState(newState)
      }

      return newState
    },
    [intakeState]
  )
  // try a different method to get rid of stale state issues
  // const updateIntakeStateAtKey = useCallback((object) => {
  //   return setIntakeState((prevState) => {
  //     const newState = { ...prevState, ...object }
  //     return newState
  //   })
  // }, [])

  // const updateUser = async (userIntakeState = intakeState, operationType) => {
  //   // remove createdAt, updatedAt, and recommendations from intakeState to submit values
  //   // remove sections: familydependents, goals tasks and notes, tsp, fegli, and address
  //   // console.log(intakeState)
  //   const {
  //     assets,
  //     liabilities,
  //     deductions,
  //     createdAt,
  //     updatedAt,
  //     recommendations,
  //     familyDependents,
  //     userNotes,
  //     userGoals,
  //     userTasks,
  //     riskTolerance,
  //     riskScore,
  //     hasFinancialAdvisor,
  //     totalInvestableAssets,
  //     savingsGoal,
  //     tspAllocation,
  //     tspRothAllocation,
  //     address,
  //     address2,
  //     city,
  //     state,
  //     fegliExtraABL,
  //     fegliExtraBLReduction,
  //     fegliExtraAReduction,
  //     fegliExtraBKeep,
  //     fegliExtraCKeep,
  //     healthInsurancePremiumRetirement,
  //     // retirementType,
  //     plannedSickLeave,
  //     privateLifeInsurance,
  //     salesforceAccountID,
  //     salesforceLeadID,
  //     salesforceICEventID,
  //     retirementStrategist,
  //     deductionTypesToInput,
  //     selectedDeductions,
  //     tspLoanToSubmit,
  //     ...submittableValues
  //   } = userIntakeState || intakeState
  //   const familyValues = {
  //     _version: userIntakeState._version,
  //     familyChildren: userIntakeState.familyChildren,
  //     familyDependents,
  //   }
  //   const goalsValues = {
  //     _version: userIntakeState._version,
  //     userNotes,
  //     userGoals,
  //     userTasks,
  //   }
  //   const financeValues = {
  //     _version: userIntakeState._version,
  //     riskTolerance,
  //     riskScore,
  //     hasFinancialAdvisor,
  //     totalInvestableAssets,
  //     savingsGoal,
  //     tspAllocation,
  //     tspRothAllocation,
  //   }
  //   const fegliValues = {
  //     _version: userIntakeState._version,
  //     fegliExtraABL,
  //     fegliExtraBLReduction,
  //     fegliExtraAReduction,
  //     fegliExtraBKeep,
  //     fegliExtraCKeep,
  //     privateLifeInsurance,
  //     healthInsurancePremiumRetirement,
  //     // retirementType,
  //     plannedSickLeave,
  //   }
  //   const addressValues = {
  //     _version: userIntakeState._version,
  //     address,
  //     address2,
  //     city,
  //     state,
  //     zipcode: userIntakeState.zipcode,
  //   }
  //   const sfValues = {
  //     _version: userIntakeState._version,
  //     salesforceAccountID,
  //     salesforceLeadID,
  //     salesforceICEventID,
  //     retirementStrategist,
  //   }
  //   const valuesMap = {
  //     family: familyValues,
  //     goals: goalsValues,
  //     finance: financeValues,
  //     fegli: fegliValues,
  //     address: addressValues,
  //     salesforce: sfValues,
  //   }
  //   const selectedValues = valuesMap[operationType] || submittableValues
  //   const mutationMap = {
  //     family: updateParcoUserFamily,
  //     goals: updateParcoUserGoalsTasksAndNotes,
  //     finance: updateParcoUserFinances,
  //     fegli: updateParcoUserFegli,
  //     address: updateParcoUserAddress,
  //     salesforce: updateParcoUserSalesforce,
  //   }
  //   const mutation = mutationMap[operationType] || updateParcoUser

  //   // console.log('userIntakeState:', userIntakeState)
  //   // console.log('intakeState:', intakeState)

  //   // console.log(operationType)
  //   // console.log(mutation)
  //   // console.log('selected values:', selectedValues)

  //   try {
  //     const data = await API.graphql(
  //       graphqlOperation(mutation, {
  //         input: {
  //           ...selectedValues,
  //           id: assumedUser || userIntakeState.id,
  //         },
  //       })
  //     )

  //     const updatedData = data?.data?.updateParcoUser || {}

  //     updateIntakeStateAtKey({
  //       ...updatedData,
  //       _version: updatedData._version,
  //     })

  //     makeRecommendation({
  //       notify: !window.location.pathname.startsWith('/onboarding'),
  //     })
  //     setCurrentErrors({})
  //     return true
  //   } catch (e) {
  //     console.error(e)
  //     console.log(errorMapping)
  //     const erroredField = e.errors.map((item) => {
  //       return item.message.match(/'([^']*)'/)[1]
  //     })
  //     console.log(erroredField)
  //     const warningMessage = errorMapping[erroredField]
  //       ? `There was an issue submitting the ${errorMapping[erroredField]}`
  //       : 'There was an issue submitting your answer to that last question. Please try again.'
  //     toast.warn(warningMessage, {
  //       position: 'top-right',
  //       autoClose: 5000,
  //       pauseOnFocusLoss: false,
  //     })
  //     setCurrentErrors({ [erroredField]: warningMessage })

  //     // IF THIS DOESN'T BREAK, LET'S REMOVE THIS COMMENT
  //     // findUser(assumedUser || intakeState.id, false)
  //     return false
  //   }
  // }

  const updateUser = useCallback(
    async (userIntakeState = intakeState) => {
      // remove createdAt, updatedAt, and recommendations from intakeState to submit values
      // console.log(intakeState)
      const {
        assets,
        liabilities,
        deductions,
        createdAt,
        updatedAt,
        recommendations,
        deductionTypesToInput,
        selectedDeductions,
        tspLoanToSubmit,
        plaidAccessTokens,
        tasks,
        id,
        ...submittableValues
      } = userIntakeState || intakeState
      try {
        let parcoUser = await updateUserFunc(id, submittableValues)

        updateIntakeStateAtKey({
          ...parcoUser,
        })

        // makeRecommendation({
        //   notify: !window.location.pathname.startsWith('/onboarding'),
        // })
        setCurrentErrors({})
        return true
      } catch (e) {
        console.error(e)
        // console.log(errorMapping)
        const erroredField = e.errors.map((item) => {
          return item.message.match(/'([^']*)'/)[1]
        })
        // console.log(erroredField)
        const warningMessage = errorMapping[erroredField]
          ? `There was an issue submitting the ${errorMapping[erroredField]}`
          : 'There was an issue submitting your answer to that last question. Please try again.'
        toast.warn(warningMessage, {
          position: 'top-right',
          autoClose: 5000,
          pauseOnFocusLoss: false,
        })
        setCurrentErrors({ [erroredField]: warningMessage })

        return false
      }
    },
    [intakeState, updateIntakeStateAtKey]
  )

  const contextValue = useMemo(
    () => ({
      intakeState,
      setIntakeState,
      updateIntakeStateAtKey,
      updateUser,
      userTasks,
      loading,
      isAdmin,
      adminDetails,
      isAgency,
      assumeUserAccount,
      assumedUser,
      unassume,
      signOut,
      loggedInUserId,
      reloadUser,
      nonUserState,
      setNonUserState,
      currentErrors,
    }),
    [
      intakeState,
      setIntakeState,
      updateIntakeStateAtKey,
      updateUser,
      userTasks,
      loading,
      isAdmin,
      adminDetails,
      isAgency,
      assumeUserAccount,
      assumedUser,
      unassume,
      signOut,
      loggedInUserId,
      reloadUser,
      nonUserState,
      setNonUserState,
      currentErrors,
    ]
  )

  return (
    <IntakeContext.Provider value={contextValue}>
      {children}
    </IntakeContext.Provider>
  )
}

export default IntakeContextWrapper
